import URLSearchParams from 'url-search-params'
import { pathOr } from 'ramda'

import selectRateAction from './selectRate'
import { HOTEL_PAGE_PARAM_RATE_ID } from '../constants'
import setUrlParams from '../urlParams'

const preselectRates = async (roomId, dispatch, getState) => {
  const { main: { rooms } } = getState()
  const roomRates = pathOr([], ['roomRates'], rooms.find(room => room.id === roomId))
  const searchParams = new URLSearchParams(window.location.search)
  const paramsRoomRateId = searchParams.get(HOTEL_PAGE_PARAM_RATE_ID)
  const availableRatesIdArr = roomRates.map(rate => rate.id)
  let selectedRateId = null
  const rate = roomRates.find(el => el.backRolledId === paramsRoomRateId)

  if (
    paramsRoomRateId
    && paramsRoomRateId.length
    && (rate || availableRatesIdArr.find(el => el === paramsRoomRateId))
  ) {
    if (rate) {
      selectedRateId = rate.id
    } else {
      selectedRateId = paramsRoomRateId
    }
  } else {
    selectedRateId = roomRates[0].id
  }

  await dispatch(selectRateAction(roomId, selectedRateId))

  searchParams.set(HOTEL_PAGE_PARAM_RATE_ID, selectedRateId)
  setUrlParams(searchParams)
}

export default roomId => (dispatch, getState) => preselectRates(roomId, dispatch, getState)
